'use client';

import { getLegalLinks } from './constants';
import { ApplyStaticText } from '$/(cms)/-cms/apply-v3/[[...slugs]]/i18n';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

export function LegalText() {
  const context = useClientContext();
  const staticText = getClientTranslations(ApplyStaticText, context);
  const legalLinks = getLegalLinks(context.lang);
  const currentYear = new Date().getFullYear();
  const footerCopyright = staticText.footerCopyright.replace(
    '${currentYear}',
    String(currentYear),
  );
  const footerLinkClass = 'underline text-[#8f8f8f]';

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <div className="flex flex-col gap-3 text-[#8f8f8f] text-sm leading-[18px]">
      <p className="flex flex-wrap items-center gap-x-2">
        <a
          className={footerLinkClass}
          href={legalLinks.footer.termsAndConditions}
          rel="noopener noreferrer"
          target="_blank"
        >
          {staticText.termsAndConditions}
        </a>
        <span>{staticText.footerLinksSeparator}</span>
        <a
          className={footerLinkClass}
          href={legalLinks.footer.privacyPolicy}
          rel="noopener noreferrer"
          target="_blank"
        >
          {staticText.privacyPolicy}
        </a>
      </p>
      <p>{footerCopyright}</p>
    </div>
  );
}
